import React from "react";

export const Rectangle = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="true"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 19 19"
    >
      <path
        d="M0 85V0h170v170H0V85zm140 0V30H30v110h110V85z"
        transform="matrix(.1 0 0 -.1 0 17)"
      />
    </svg>
  );
};
